import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Search } from "lucide-react";
import { API, getAuthHeader } from "@/App";

// Admin: paste the trace ID printed on a leaked Order Register sheet.
export const ExportTraceLookup = () => {
  const [tid, setTid] = useState("");
  const [hit, setHit] = useState(null);
  const lookup = async () => {
    setHit(null);
    try {
      const r = await axios.get(`${API}/order-register/export-trace/${encodeURIComponent(tid.trim())}`,
        { headers: getAuthHeader() });
      setHit(r.data);
    } catch (e) { toast.error(e.response?.data?.detail || "Lookup failed"); }
  };
  return (
    <div className="border border-slate-200 rounded-lg p-3 bg-slate-50" data-testid="export-trace-lookup">
      <div className="text-sm font-semibold text-slate-700 mb-2">Leaked sheet? Trace an export</div>
      <div className="flex gap-2">
        <input value={tid} onChange={e => setTid(e.target.value)} onKeyDown={e => e.key === "Enter" && lookup()}
          placeholder="Trace ID, e.g. 3FA9C21B" data-testid="export-trace-input"
          className="h-8 px-2 border border-slate-300 rounded text-sm font-mono uppercase w-56" />
        <button onClick={lookup} disabled={!tid.trim()} data-testid="export-trace-btn"
          className="h-8 px-3 rounded bg-slate-800 text-white text-sm inline-flex items-center gap-1 disabled:opacity-50">
          <Search className="w-3.5 h-3.5" /> Find
        </button>
      </div>
      {hit && (
        <div className="mt-2 text-xs text-slate-700 grid grid-cols-2 gap-x-4 gap-y-0.5" data-testid="export-trace-result">
          <span><b>By:</b> {hit.name} ({hit.email})</span><span><b>Team:</b> {hit.team || "-"}</span>
          <span><b>When:</b> {new Date(hit.at).toLocaleString()}</span><span><b>IP:</b> {hit.ip || "-"}</span>
          <span><b>Type:</b> {hit.kind}</span><span><b>Rows:</b> {hit.rows}</span>
          <span className="col-span-2"><b>Filters:</b> {Object.entries(hit.filters || {}).map(([k, v]) => `${k}=${v}`).join(", ") || "none"}</span>
        </div>
      )}
    </div>
  );
};
